import { render, staticRenderFns } from "./changeCandidateStatus.vue?vue&type=template&id=480f6193&scoped=true"
import script from "./changeCandidateStatus.vue?vue&type=script&lang=js"
export * from "./changeCandidateStatus.vue?vue&type=script&lang=js"
import style0 from "./changeCandidateStatus.vue?vue&type=style&index=0&id=480f6193&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480f6193",
  null
  
)

export default component.exports